import { z } from 'zod'

export const SystemFeature = z.enum([
  'INTERFERING_BEHAVIOR',
  'GROUPS',
  'AGENDA',
  'SESSION',
  'FOOD',
  'CHAT',
  'LIQUID',
  'PATIENTS',
  'MEDICAL_RECORD',
  'BATHROOM',
  'REMEDIES',
  'BELONGINGS',
  'SLEEP',
  'BODY_EXAM',
  'PATIENT_CONFIG',
  'TASKS',
  'TICKETS',
  'PATIENT_COMMENTS',
  'DRIVE',
  'SESSION_MANAGEMENT',
  'OCCURRENCES_MANAGEMENT',
  'FREQUENCY_MANAGEMENT',
  'ABSENCE_MANAGEMENT',
  'GENERAL',
  'NOTIFICATIONS',
  'BELONGINGS_MANAGEMENT',
  'FOOD_MANAGEMENT',
  'REMEDIES_MANAGEMENT',
  'NEW'
])

export type SystemFeature = z.infer<typeof SystemFeature>
